module.exports = __webpack_public_path__ + "static/img/index9.c6b412d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/index9.jpg
// module id = 9aPN
// module chunks = 9